var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product != null && _vm.product.description != null)?_c('div',{staticClass:"tab-pane fade",class:_vm.activeTab === 'review' ? 'in active show' :'',attrs:{"id":"review"}},[_c('div',{staticClass:"fontsize-small text-color-666 text-justify line-height2 p-3",domProps:{"innerHTML":_vm._s(_vm.product.description)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }